module.exports = __webpack_public_path__ + "static/media/recurring-icon.58b36e75.svg";